/** @ngInject */
export class ExportModalBean {
    constructor(supportedExports, params, group) {
        this.supportedExports = supportedExports;
        this.params = params;
        this.group = group;
    }
}
